module.exports = __webpack_public_path__ + "static/media/hydro_dam_icon.95f73d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hydro_dam_icon.png
// module id = 690
// module chunks = 0